import styled, { css } from 'styled-components'

import pageWrapperBgImage from 'images/commissioned-bg-login.png'

export const PublicPageWrapper = styled.div(
  ({ theme }) => css`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 100%;
  background: ${theme.colors.blues.A800} url('${pageWrapperBgImage}') no-repeat center;
  background-size: cover;
  background-attachment: fixed;

  @media (min-width: ${theme.breakpoints[1]}) {
    padding: 32px 0;
  }

`,
)

export default PublicPageWrapper
